import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';

export interface EnvironmentVariableConfig {
  headerBackgroundColour: string;
}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentVariableService {
  private static ENVIRONMENT_VARIABLES_JSON_LOCATION: string = '/assets/environment-variables.json';

  private config: EnvironmentVariableConfig;

  private _environmentVariableSubject: BehaviorSubject<EnvironmentVariableConfig> =
    new BehaviorSubject<EnvironmentVariableConfig>({} as EnvironmentVariableConfig);

  constructor(private _http: HttpClient) {}

  public loadConfig() {
    this._http
      .get(EnvironmentVariableService.ENVIRONMENT_VARIABLES_JSON_LOCATION)
      .toPromise()
      .then((data: any) => {
        this.config = {
          headerBackgroundColour: this._validateBackgroundColour(data.headerBackgroundColour),
        };
        this._environmentVariableSubject.next(this.config);
      });
  }

  private _validateBackgroundColour(backgroundColour: string): string {
    const regex: RegExp = /^#[0-9A-F]{6}$/i;
    if (regex.test(backgroundColour)) {
      return backgroundColour;
    }
    return '#FFFFFF';
  }

  public onConfigChange(cb: (config: EnvironmentVariableConfig) => void): Subscription {
    return this._environmentVariableSubject.subscribe(cb);
  }

  public getConfig(): EnvironmentVariableConfig {
    return Object.assign({}, this.config);
  }
}
